import styled from 'styled-components';

export const TransactionInfoContainer = styled.ul`
  display: flex;
  flex-direction: column;
  align-items:flex-start;
  justify-content: center;
  li {
    padding: 15px 0;
    width: 100%;
    &:not(:last-child) {
      border-bottom: 1px dotted #d8d8d8;

    }
  }
  p {
    color: #333;
    font-size: 1rem;
    b {
      margin-left:5px;
    }
  }
`;

